export class subCategory{
    _id:any;
    categoryId:any;
    name:string
    adminId:any
    adminUserName:any
   gender:any
    logo:any
    status:boolean
}